import React from 'react';
import BrandsCarousel from '../../BrandsCarousel/BrandsCarousel';
import ContentSections from '../HeroContent/ContentSections';
import MissionStatement from '../MissionStatement/MissionStatement';
import InfoContainer from '../InfoContainer/InfoContainer';
import './Home.css';
import Hero from '../Hero/Hero';
import PurposeSection from '../../PurposeSection/PurposeSection';

const Home = () => {
  return (
    <div className="home-container">
      {/* Hero section - likely full-width background */}
      <section className="hero-home-container">
        <div className="container">
          <Hero />
        </div>
      </section>

      {/* Brands carousel - full-width background with contained content */}
      <section className="brands-wrapper">
        <BrandsCarousel />
      </section>

      {/* Info container - contained content */}
      <section className="info-container-home-content">
        <div className="container">
          <InfoContainer />
        </div>
      </section>

      {/* Content sections - full-width background with contained content */}
      <section className="content-sections-wrapper">
        <div className="container">
          <ContentSections />
        </div>
      </section>

      {/* Mission statement - full-width background with contained content */}
      <section className="mission-statement-wrapper">
        <div className="container">
          <MissionStatement />
        </div>
      </section>

      {/* Purpose section - full-width background with contained content */}
      <section className="purpose-wrapper">
        <div className="container">
          <PurposeSection />
        </div>
      </section>
    </div>
  );
};

export default Home;
